{
  "AI-Added": "AI-Added",
  "Activity Date": "Activity Date",
  "Applied Filters ({{count}})_one": "Applied Filters ({{count}})",
  "Applied Filters ({{count}})_other": "Applied Filters ({{count}})",
  "Apply": "Apply",
  "Appointment Time": "Appointment Time",
  "Appointment Type": "Appointment Type",
  "By {{actorUserName}}": "By {{actorUserName}}",
  "Calendar": "Calendar",
  "Canceled": "Canceled",
  "Created": "Created",
  "Current Status": "Current Status",
  "Direct Booked": "Direct Booked",
  "End: {{date}}": "End: {{date}}",
  "Event": "Event",
  "Filters": "Filters",
  "Other": "Other",
  "PMS Added": "PMS Added",
  "Patient": "Patient",
  "Patient Added": "Patient Added",
  "Refresh Data": "Refresh Data",
  "Requested": "Requested",
  "Rescheduled": "Rescheduled",
  "Reset": "Reset",
  "Schedule Activity": "Schedule Activity",
  "Schedule an appointment to begin building your practice history.": "Schedule an appointment to begin building your practice history.",
  "Service": "Service",
  "Source": "Source",
  "Staff Added": "Staff Added",
  "Start: {{date}}": "Start: {{date}}",
  "Status": "Status",
  "Time": "Time",
  "Time Frame": "Time Frame",
  "Via Schedule Request": "Via Schedule Request",
  "Via Waitlist": "Via Waitlist",
  "Via online scheduling": "Via online scheduling",
  "Your schedule activity is empty": "Your schedule activity is empty"
}
